// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import axios from './axiosJWTDecorator';
import { getBaseUrl } from '../configVariables';

let baseAxiosUrl = getBaseUrl() + '/api';



export const postChannelInfo =  async (channelId: string): Promise<any> => {
    let url = baseAxiosUrl + `/stations?teamId=${channelId}`;
    return await axios.post(url);
}

export const getChannelInfo = async (channelId: string): Promise<any> => {
    let url = baseAxiosUrl + `/stations?teamId=${channelId}`;
    return await axios.get(url);
}

export const getSentNotifications = async (): Promise<any> => {
    let url = baseAxiosUrl + "/sentnotifications";
    return await axios.get(url);
}

export const getDraftNotifications = async (): Promise<any> => {
    let url = baseAxiosUrl + "/draftnotifications";
    return await axios.get(url);
}

export const getScheduledNotifications = async (): Promise<any> => {
    let url = baseAxiosUrl + "/sentnotifications/scheduled";
    return await axios.get(url);
}




export const verifyGroupAccess = async (): Promise<any> => {
    let url = baseAxiosUrl + "/groupdata/verifyaccess";
    return await axios.get(url, false);
}

export const getGroups = async (id: number): Promise<any> => {
    let url = baseAxiosUrl + "/groupdata/" + id;
    return await axios.get(url);
}

export const searchGroups = async (query: string): Promise<any> => {
    let url = baseAxiosUrl + "/groupdata/search/" + query;
    return await axios.get(url);
}

export const resentNotification = async (id: string): Promise<any> => {
    let url = baseAxiosUrl + `/sentNotifications/${id}/resend`;
    return await axios.get(url);
}

export const exportNotification = async (payload: {}): Promise<any> => {
    let url = baseAxiosUrl + "/exportnotification/export";
    return await axios.put(url, payload);
}

export const getSentNotification = async (id: number): Promise<any> => {
    let url = baseAxiosUrl + "/sentnotifications/" + id;
    return await axios.get(url);
}

export const getDraftNotification = async (id: number): Promise<any> => {
    let url = baseAxiosUrl + "/draftnotifications/" + id;
    return await axios.get(url);
}


export const deleteDraftNotification = async (id: number): Promise<any> => {
    let url = baseAxiosUrl + "/draftnotifications/" + id;
    return await axios.delete(url);
}

export const duplicateDraftNotification = async (id: number): Promise<any> => {
    let url = baseAxiosUrl + "/draftnotifications/duplicates/" + id;
    return await axios.post(url);
}

export const sendDraftNotification = async (payload: {}): Promise<any> => {
    let url = baseAxiosUrl + "/sentnotifications";
    return await axios.post(url, payload);
}

export const updateDraftNotification = async (payload: {}): Promise<any> => {
    let url = baseAxiosUrl + "/draftnotifications";
    return await axios.put(url, payload);
}

export const createDraftNotification = async (payload: {}): Promise<any> => {
    let url = baseAxiosUrl + "/draftnotifications";
    return await axios.post(url, payload);
}

export const getTeams = async (): Promise<any> => {
    let url = baseAxiosUrl + "/teamdata";
    return await axios.get(url);
}

export const getConsentSummaries = async (id: number): Promise<any> => {
    let url = baseAxiosUrl + "/draftnotifications/consentSummaries/" + id;
    return await axios.get(url);
}

export const sendPreview = async (payload: {}): Promise<any> => {
    let url = baseAxiosUrl + "/draftnotifications/previews";
    return await axios.post(url, payload);
}

export const getAuthenticationConsentMetadata = async (windowLocationOriginDomain: string, login_hint: string): Promise<any> => {
    let url = `${baseAxiosUrl}/authenticationMetadata/consentUrl?windowLocationOriginDomain=${windowLocationOriginDomain}&loginhint=${login_hint}`;
    return await axios.get(url, undefined, false);
}
//Get all Stations
export const getAllStations = async (): Promise<any> => {
    let url = baseAxiosUrl + "/stations";
    return await axios.get(url);
}
//Get Users
export const getUsers = async (id: number): Promise<any> => {
    let url = baseAxiosUrl + "/userdata/" + id;
    return await axios.get(url);
}

export const searchUsers = async (query: string): Promise<any> => {
    let url = baseAxiosUrl + "/userdata/search/" + query;
    return await axios.get(url);
}

export const getWithDrawntNotifications = async (): Promise<any> => {
    let url = baseAxiosUrl + "/withdrawnNotifications";
    return await axios.get(url);
}
export const getWithDrawnNotification = async (id: number): Promise<any> => {
    let url = baseAxiosUrl + "/withdrawnNotifications/" + id;
    return await axios.get(url);
}

export const postWithDrawntNotifications = async (id: number): Promise<any> => {
    let url = `${baseAxiosUrl}/withdrawnNotifications/${id}`;
    return await axios.post(url);
}


export const postFileToBlob = async (files: FileList): Promise<any> => {
    const data = new FormData()
    data.append('files', files[0])

    let url = `${baseAxiosUrl}/draftNotifications/files`;
    return await axios.post(url, data);
}

export const getViewFile = async (user: string, notifcation: string): Promise<any> => {

    let url = `${baseAxiosUrl}/viewfile/fileinfo/${notifcation}/${user}`;
    return await axios.get(url, true, false);
}

export const postViewFile = async (user: string, notifcation: string): Promise<any> => {

    let url = `${baseAxiosUrl}/viewfile/sign/${notifcation}/${user}`;

    return await fetch(url, {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(response.statusText)
            }
            return response;
        })

}

export const getFileType = async (url: string): Promise<any> => {  

    return await fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(response.statusText)
            }
            return response.headers.get("Content-Type");
        })

}

export const getTeamsData = async (id: number): Promise<any> => {
    let url = baseAxiosUrl + `/insights/teams/${id}`;
    return await axios.get(url);
}

export const getUserData = async (id: number): Promise<any> => {
    let url = baseAxiosUrl + `/insights/users/${id}`;
    return await axios.get(url);
}